export default "__VITE_ASSET__DYDzGGml__"